module.exports = __webpack_public_path__ + "media/images/premium/premium-card-bg-91770a239484ac67cee682ff58285356.svg";